import Vue from 'vue'
import Router from 'vue-router'

import Index from './views/Index'
import newIndex from './views/news/index.vue'
import newDetail from './views/news/detail.vue'
import noticeIndex from './views/notice/index.vue'
import bulletinIndex from './views/notice/bulletin.vue'
import noticeDetail from './views/notice/detail.vue'
import supervisionIndex from './views/supervision/index.vue'
import supervisionDetail from './views/supervision/detail.vue'
import comprehensiveControlIndex from './views/comprehensiveControl/index.vue'
import comprehensiveControlDetail from './views/comprehensiveControl/detail.vue'
import monitoringIndex from './views/monitoring/index.vue'
import monitoringDetail from './views/monitoring/detail.vue'
import institutionalFunctionIndex from './views/institutionalFunction/index.vue'
import institutionalFunctionDetail from './views/institutionalFunction/detail.vue'
import policiesAndRegulationsIndex from './views/policiesAndRegulations/index.vue'
import policiesAndRegulationsDetail from './views/policiesAndRegulations/detail.vue'
import popularScienceKnowledgeIndex from './views/popularScienceKnowledge/index.vue'
import popularScienceKnowledgeDetail from './views/popularScienceKnowledge/detail.vue'
import creditManagementIndex from './views/creditManagement/index.vue'
import creditManagementDetail from './views/creditManagement/detail.vue'
import searchIndex from './views/search/index.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            components: {default:Index},
            meta:{
                index:0
            }
        },
        {
            path: '/newIndex',
            components: { default:newIndex},
            meta:{
                index:1
            }
        },
        {
            path: '/newDetail/:id',
            components: {default:newDetail},
            meta:{
                index:1
            }
        },
        {
            path: '/noticeIndex',
            components: {default:noticeIndex},
            meta:{
                index:2
            }
        },
        {
            path: '/bulletinIndex', // 水保公报
            components: {default:bulletinIndex},
            meta:{
                index:2
            }
        },
        {
            path: '/noticeDetail/:id',
            components: {default:noticeDetail},
            meta:{
                index:2
            }
        },
        {
            path: '/supervisionIndex',
            components: {default:supervisionIndex},
            meta:{
                index:3
            }
        },
        {
            path: '/supervisionDetail/:id',
            components: { default:supervisionDetail},
            meta:{
                index:3
            }
        },
        {
            path: '/comprehensiveControlIndex',
            components: { default:comprehensiveControlIndex},
            meta:{
                index:4
            }
        },
        {
            path: '/comprehensiveControlDetail/:id',
            components: { default:comprehensiveControlDetail},
            meta:{
                index:4
            }
        },
        {
            path: '/policiesAndRegulationsIndex',
            components: { default:policiesAndRegulationsIndex},
            meta:{
                index:6
            }
        },
        {
            path: '/policiesAndRegulationsDetail/:id',
            components: { default:policiesAndRegulationsDetail},
            meta:{
                index:6
            }
        },
        {
            path: '/monitoringIndex',
            components: { default:monitoringIndex},
            meta:{
                index:5
            }
        },
        {
            path: '/monitoringDetail/:id',
            components: { default:monitoringDetail},
            meta:{
                index:5
            }
        },
        {
            path: '/institutionalFunctionIndex',
            components: { default:institutionalFunctionIndex},
            meta:{
                index:7
            }
        },
        {
            path: '/institutionalFunctionDetail/:id',
            components: { default:institutionalFunctionDetail},
            meta:{
                index:7
            }
        },
        {
            path: '/popularScienceKnowledgeIndex',
            components: { default:popularScienceKnowledgeIndex},
            meta:{
                index:8
            }
        },
        {
            path: '/popularScienceKnowledgeDetail/:id',
            components: { default:popularScienceKnowledgeDetail},
            meta:{
                index:8
            }
        },
        {
            path: '/creditManagementIndex',
            components: { default:creditManagementIndex},
            meta:{
                index:9            }
        },
        {
            path: '/creditManagementDetail/:id',
            components: { default:creditManagementDetail},
            meta:{
                index:9
            }
        },
        {
            path: '/searchIndex',
            components: { default:searchIndex}
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router.js